import { useGLTF } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'
import { useMemo, useRef } from 'react'

function CircuitTrail({ bikeColor, ...props }) {
  const { nodes, materials } = useGLTF('/trail6.glb')
  const trailRef = useRef()

 

  useFrame(({ clock }) => {
    if (trailRef.current) {
      const material = trailRef.current.material
      material.map.offset.x = -clock.elapsedTime * 2.5
      material.map.offset.y = -clock.elapsedTime * 0.5
      material.emissive = bikeColor
      material.emissiveIntensity = 5
      material.color = bikeColor
    }
  })

  return (
    <group {...props}>
      <mesh ref={trailRef} {...nodes.Plane} material={materials['Material.001']} />
    </group>
  )
}
export default CircuitTrail
